exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  box-shadow: none;\n  overflow: hidden; }\n\n.link {\n  color: #46525d; }\n\n.rural-image {\n  height: 48px;\n  width: 48px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 50%; }\n  .rural-image img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    height: 100%;\n    width: auto; }\n\n.user-column {\n  width: 100%; }\n\n@media screen and (min-width: 0px) {\n  .rural-name {\n    font-size: 16px; }\n  .user-title {\n    font-size: 20px; } }\n\n@media screen and (min-width: 768px) {\n  .rural-name {\n    font-size: 18px; }\n  .user-title {\n    font-size: 22px; } }\n\n@media screen and (min-width: 1024px) {\n  .rural-name {\n    font-size: 20px; }\n  .user-title {\n    font-size: 24px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-list/user-list.component.scss
// module id = ../../../../../src/app/users/user-list/user-list.component.scss
// module chunks = 1